import React, { Fragment, useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { translate } from '../Services/translation';
import InputField from './InputField';
import { post } from '../Services/http';
import { useDispatch } from 'react-redux';
import { addFlashMessage } from '../Actions/FlashMessages.action';
import { receive as receiveOwned } from '../Actions/UserOwnedFullLicenseProducts.action';
import { receive as receiveCreditPurchaseModal } from '../Actions/FlowCreditPurchaseModal.action';
import { receive as receiveCreditUpgradePurchaseModal } from '../Actions/FlowCreditUpgradePurchaseModal.action';

const FlowCreditsPurchaseModal = ({isUpgrade}) => {
    const dialogRef = useRef(null);
    const dispatch = useDispatch();
    const flowCreditPurchaseModal = useSelector((state) => state.flowCreditPurchaseModal);
    const flowCreditUpgradePurchaseModal = useSelector((state) => state.flowCreditUpgradePurchaseModal);
    const [model, setModel] = useState(isUpgrade === "true" ? flowCreditUpgradePurchaseModal : flowCreditPurchaseModal);
    const [showAlreadyOwnes, setShowAlreadyOwnes] = useState(model.currentUserOwnsProduct);
    const [showForm, setShowForm] = useState(!showAlreadyOwnes);
    const [showConfirm, setShowConfirm] = useState(false);
    const [showDepositSuccess, setShowDepositSuccess] = useState(false);
    const [isDepositing, setIsDepositing] = useState(false);
    const [customerCreditsList, setCustomerCreditsList] = useState(model.customerCreditsList);

    useEffect(() => {
        setModel(isUpgrade === "true" ? flowCreditUpgradePurchaseModal : flowCreditPurchaseModal)
        setCustomerCreditsList(isUpgrade === "true" ? flowCreditUpgradePurchaseModal.customerCreditsList : flowCreditPurchaseModal.customerCreditsList);
    }, [flowCreditPurchaseModal, flowCreditUpgradePurchaseModal]);
    
    const onSelectedCreditsChange = (id, newSelectedCredits) => {    
        var nextCustomerCreditsList = customerCreditsList.map(customerCredits => {
            if (customerCredits.id === id) {
                newSelectedCredits = newSelectedCredits > customerCredits.availableCredits ? customerCredits.availableCredits : newSelectedCredits;
                newSelectedCredits = newSelectedCredits < 0 ? 0 : newSelectedCredits;
                return { ...customerCredits, selectedCredits: newSelectedCredits };
            } else {
                return customerCredits;
            }
        })

        setCustomerCreditsList(nextCustomerCreditsList.map(customerCredits => {
            let sumOthers = nextCustomerCreditsList.reduce((total, c) => total + (c.id === customerCredits.id ? 0 : c.selectedCredits), 0);
            let remaining = model.creditPrice - sumOthers;

            return { ...customerCredits, maxSelectableCredits: (remaining < customerCredits.availableCredits ? Math.max(0, remaining) : customerCredits.availableCredits) };
        }));
    };

    const selectedTotal = () => {
        return customerCreditsList.reduce((total, c) => total + c.selectedCredits, 0);
    };

    const canSubmitForm = () => {
        return model.creditPrice === selectedTotal();
    };

    const closeModal = () => {
        dialogRef.current.close();
        enableBodyScroll();
    };

    const showModal = () => {
        setShowAlreadyOwnes(model.currentUserOwnsProduct)
        setShowForm(!model.currentUserOwnsProduct);
        setShowConfirm(false);
        setShowDepositSuccess(false);
        dialogRef.current.showModal();
        stopBodyScroll();
    }

    const onShowForm = () => {
        setShowAlreadyOwnes(false);
        setShowForm(true);
    }

    const onShowConfirm = () => {
        setShowForm(false);
        setShowConfirm(true);
    }

    const onCancelConfirm = () => {
        setShowConfirm(false);
        setShowForm(true);
    }

    const onSubmit = () => {
        setIsDepositing(true);

        post('/api/products/purchaseWithFlowCredits', {customerCreditsList, fullProductArticleNumber: flowCreditPurchaseModal.productArticleNumber, upgradeProductArticleNumber: flowCreditUpgradePurchaseModal.productArticleNumber, isUpgrade: (isUpgrade === "true")})
            .then((response) => response.json())
            .then((responseModel) => {
                dispatch(receiveOwned(responseModel.userOwnedFullLicenseProducts));
                if (flowCreditPurchaseModal?.productArticleNumber) {
                    dispatch(receiveCreditPurchaseModal({ ...flowCreditPurchaseModal, customerCreditsList: responseModel.fullProductCustomerCreditsList, currentUserOwnsProduct: true }));
                }
                if (flowCreditUpgradePurchaseModal?.productArticleNumber) {
                    dispatch(receiveCreditUpgradePurchaseModal({ ...flowCreditUpgradePurchaseModal, customerCreditsList: responseModel.upgradeProductCustomerCreditsList, currentUserOwnsProduct: true }));
                }
                setShowConfirm(false);
                setIsDepositing(false);
                setShowDepositSuccess(true);
            })
            .catch((ex) => {
                if (ex.response) {
                    ex.response.json().then((error) => {
                        if (error.general) {
                            dispatch(addFlashMessage({ messageText: error.general[0], messageType: "Pink", dismissible: true, timeToLive: 10 }));
                        } else {
                            dispatch(addFlashMessage({ messageText: translate('general.error'), messageType: "Pink", dismissible: true, timeToLive: 10 }));
                        }
                    });
                } else {
                    dispatch(addFlashMessage({ messageText: translate('general.error'), messageType: "Pink", dismissible: true, timeToLive: 10 }));
                }
                setIsDepositing(false);
            });
    }

    return (
        <Fragment>
            {model &&
                <Fragment>
                    {customerCreditsList && customerCreditsList.length > 0 && 
                        <Fragment>
                            <hr />
                            <div className="product-page__details__info__credits">
                                <button className="button" onClick={() => showModal()}>
                                    {translate('js.productpage.flowcreditpurchase.buttontext')}
                                </button>
                                {(model.creditsImagesUrls && model.creditsImagesUrls.length > 0) &&
                                    <div style={{display: 'grid', position: 'relative',  gridTemplateColumns: 'repeat(' + (model.creditsImagesUrls.length + 1) + ', 1fr)' }}>
                                        {model.creditsImagesUrls.map((creditsImagesUrl, index) => (
                                            <img key={index} style={{ gridRow: 1, gridColumn: (index + 1) + ' / span 2', zIndex: index }} src={creditsImagesUrl} />
                                        ))}
                                    </div>
                                }
                                <span>{model.creditPrice}</span>
                                {translate('js.general.credits.currency.suffix')}
                            </div>
                        </Fragment>
                    }

                    <dialog ref={dialogRef} className="dialog">
                        {!isDepositing &&
                            <a className="dialog__close" onClick={() => closeModal()}><i className="icon-cancel"></i></a>
                        }
                        <div>
                            <div className="flow-credit-purchase-modal">
                                {showAlreadyOwnes &&
                                    <Fragment>
                                        <div className="flow-credit-purchase-modal__head">
                                            <h3>{translate('js.flowcreditpurchasemodal.alreadyownes.heading')}</h3>
                                            <p>{translate('js.flowcreditpurchasemodal.alreadyownes.text')}</p>
                                        </div>
                                        <div className="flow-credit-purchase-modal__content">
                                            <div className="flow-credit-purchase-modal__confirm">
                                                <div className="flow-credit-purchase-modal__variant flow-credit-purchase-modal__variant--flex">
                                                    <div className="flow-credit-purchase-modal__variant__product">
                                                        {model.productImageUrl &&
                                                            <img src={model.productImageUrl} />
                                                        }
                                                        {model.productName}
                                                    </div>
                                                    <div className="flow-credit-purchase-modal__variant__credits-price">
                                                        {translate('js.flowcreditpurchasemodal.alreadyownes.owned')}
                                                    </div>

                                                </div>
                                                <div className="flow-credit-purchase-modal__buttons flow-credit-purchase-modal__buttons--flex">
                                                    <button className={`button button--full-width`} disabled={isDepositing} onClick={() => onShowForm()}>                 
                                                        <span>{translate('js.flowcreditpurchasemodal.alreadyownes.button.confirm')}</span>
                                                    </button>
                                                    <button className="button button__outline button--full-width" onClick={() => closeModal()}>
                                                        {translate('js.flowcreditpurchasemodal.alreadyownes.button.cancel')}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </Fragment>
                                }
                                {customerCreditsList && customerCreditsList.length > 0 && showForm &&
                                    <Fragment>
                                        <div className="flow-credit-purchase-modal__head">
                                            <h3>{translate('js.flowcreditpurchasemodal.selectcredits.heading')}</h3>
                                            <p>{translate('js.flowcreditpurchasemodal.selectcredits.text')}</p>
                                        </div>
                                        <div className="flow-credit-purchase-modal__content">
                                            <form className="flow-credit-purchase-modal__form">
                                                {customerCreditsList.map((customerCredits, index) => (
                                                    <Fragment key={index}>
                                                        <div className="flow-credit-purchase-modal__form__flow-credit-name">
                                                            {customerCredits.flowCreditsName}
                                                        </div>
                                                        <div className="flow-credit-purchase-modal__form__available-credits">
                                                            <img src={customerCredits.coinImageUrl} className="flow-credit-purchase-modal__coin" />
                                                            {customerCredits.availableCredits}
                                                        </div>
                                                        <div className="flow-credit-purchase-modal__form__input">
                                                            <InputField
                                                                name='selectedCredits'
                                                                type='number'
                                                                value={customerCredits.selectedCredits}
                                                                minValue={0}
                                                                maxValue={customerCredits.maxSelectableCredits}
                                                                required={true}
                                                                onChange={(value) => onSelectedCreditsChange(customerCredits.id, Number(value))}
                                                                disabled={isDepositing}
                                                            />
                                                        </div>
                                                    </Fragment>
                                                ))}
                                                <div className={`flow-credit-purchase-modal__form__message ${canSubmitForm() ? 'flow-credit-purchase-modal__text-green' : 'flow-credit-purchase-modal__text-grey'}`}>
                                                    {canSubmitForm() ? (
                                                        <Fragment>
                                                            {translate('js.flowcreditpurchasemodal.selectcredits.amountcoveredtext')}
                                                        </Fragment>
                                                    ) : (
                                                        <Fragment>
                                                            {customerCreditsList.length > 1 &&
                                                                <Fragment>
                                                                    {translate('js.flowcreditpurchasemodal.selectcredits.cancombinetext')}
                                                                </Fragment>
                                                            }
                                                        </Fragment>
                                                    )}
                                                </div>
                                                <div className={`flow-credit-purchase-modal__form__selected-credits ${canSubmitForm() && selectedTotal() != 0 ? 'flow-credit-purchase-modal__text-green' : 'flow-credit-purchase-modal__text-pink'}`}>
                                                    {selectedTotal() > 0 ? selectedTotal() : ''}
                                                </div>
                                                <div className="flow-credit-purchase-modal__variant flow-credit-purchase-modal__variant--grid-col">
                                                    <div className="flow-credit-purchase-modal__variant__product">
                                                        {model.productImageUrl &&
                                                            <img src={model.productImageUrl} />
                                                        }
                                                        {model.productName}
                                                    </div>
                                                    <div className="flow-credit-purchase-modal__variant__credits-price">
                                                        {model.creditPrice} {translate('js.general.credits.currency.suffix')}
                                                    </div>
                                                </div>
                                                <div className="flow-credit-purchase-modal__buttons flow-credit-purchase-modal__buttons--grid-col">
                                                    <button type="button" className={`button button--full-width ${isDepositing ? 'loading' : ''}`} disabled={!canSubmitForm()} onClick={() => onShowConfirm()}>                 
                                                        {canSubmitForm() ? (
                                                            <span>{translate('js.flowcreditpurchasemodal.purchase.button.enabled.text')}</span>
                                                        ) : (
                                                            <span>{translate('js.flowcreditpurchasemodal.purchase.button.disabled.text')}</span>
                                                        )}
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </Fragment>
                                }
                                {customerCreditsList && customerCreditsList.length > 0 && showConfirm &&
                                    <Fragment>
                                        <div className="flow-credit-purchase-modal__head">
                                            <h3>{translate('js.flowcreditpurchasemodal.confirmpurchase.heading')}</h3>
                                        </div>
                                        <div className="flow-credit-purchase-modal__content">
                                            <div className="flow-credit-purchase-modal__confirm">
                                                <div className="flow-credit-purchase-modal__confirm__selected">
                                                    {customerCreditsList.filter((customerCredits) => customerCredits.selectedCredits > 0).map((customerCredits, index) => (
                                                        <div className="flow-credit-purchase-modal__confirm__selected__row" key={index}>
                                                            <div>
                                                                {customerCredits.flowCreditsName}
                                                            </div>
                                                            <div></div>
                                                            <div>
                                                                <img src={customerCredits.coinImageUrl} className="flow-credit-purchase-modal__coin" />
                                                                {customerCredits.selectedCredits}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                                <div className="flow-credit-purchase-modal__variant flow-credit-purchase-modal__variant--flex">
                                                    <div className="flow-credit-purchase-modal__variant__product">
                                                        {model.productImageUrl &&
                                                            <img src={model.productImageUrl} />
                                                        }
                                                        {model.productName}
                                                    </div>
                                                    <div className="flow-credit-purchase-modal__variant__credits-price">
                                                        {model.creditPrice} {translate('js.general.credits.currency.suffix')}
                                                    </div>
                                                </div>
                                                <div className="flow-credit-purchase-modal__buttons flow-credit-purchase-modal__buttons--flex">
                                                    <button className={`button button--full-width ${isDepositing ? 'loading' : ''}`} disabled={isDepositing} onClick={() => onSubmit()}>                 
                                                        <span>{translate('js.flowcreditpurchasemodal.confirmpurchase.button.confirm')}</span>
                                                        <span className="spinner spinner--light spinner--small"></span>
                                                    </button>
                                                    <button className="button button__outline button--full-width" disabled={isDepositing} onClick={() => onCancelConfirm()}>
                                                        {translate('js.flowcreditpurchasemodal.confirmpurchase.button.cancel')}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </Fragment>
                                }
                                {showDepositSuccess &&
                                    <Fragment>
                                        <div className="flow-credit-purchase-modal__head">
                                            <h2>{translate('js.flowcreditpurchasemodal.purchase.success.heading')}</h2>
                                            <p>{translate('js.flowcreditpurchasemodal.purchase.success.text')}</p>
                                        </div>
                                        <div className="flow-credit-purchase-modal__deposited">
                                            <div className="flow-credit-purchase-modal__deposited__product">
                                                {model.productImageUrl &&
                                                    <img src={model.productImageUrl} />
                                                }
                                                {model.productName}
                                            </div>
                                            <div className="flow-credit-purchase-modal__deposited__owned">
                                                {translate('js.flowcreditpurchasemodal.purchase.success.product.owned')}
                                            </div>
                                        </div>
                                        <button className="button button__primary button--full-width" onClick={() => closeModal()}>
                                            {translate('js.flowcreditpurchasemodal.afterpurchase.button.text')}
                                        </button>
                                    </Fragment>
                                }

                            </div>
                        </div>
                    </dialog>
                </Fragment>
            }
        </Fragment>
    );
};

export default FlowCreditsPurchaseModal;
